@if (label()) {
  <label class="form-label"
    >{{ label() }}
    @if (required()) {
      <span class="text-danger">*</span>
    }
  </label>
}
@if (hasError) {
  <input placeholder="" hidden aria-hidden="true" tabindex="-1" />
}
@if (multiselect()) {
  <p-multiselect
    appendTo="body"
    [options]="displayItems()"
    [filter]="allowSearch()"
    filterBy="firstLabel,secondLabel"
    filterPlaceholder="Search..."
    optionLabel="firstLabel"
    [showToggleAll]="allowSearch()"
    [maxSelectedLabels]="maxLabels()"
    [showClear]="clearable()"
    optionValue="id"
    [placeholder]="placeholder()"
    [(ngModel)]="value"
    [virtualScroll]="virtualScroll()"
    [virtualScrollItemSize]="virtualScrollItemSize()"
    [disabled]="!!ngControl?.control?.disabled"
    [loading]="loading()"
    (ngModelChange)="onValueChange($event)"
    [invalid]="hasError"
  >
    <!-- <ng-template pTemplate="selectedItems" let-selectedOptions let-removeChip="removeChip">
      @for (option of selectedOptions; track option.id) {
        <p-chip [removable]="true" (onRemove)="removeChip(option, $event)">
          {{ option.firstLabel }}
          @if (option.secondLabel) {
            <small class="text-muted fs-14"> ({{ option.secondLabel }})</small>
          }
        </p-chip>
      }
    </ng-template> -->
    <ng-template let-item #item>
      <div class="d-flex flex-column px-1 py-1 rounded-2">
        <span class="fs-16 lh-1">{{ item.firstLabel }}</span>
        @if (item.secondLabel) {
          <small class="text-muted lh-1 fs-14 ms-1">({{ item.secondLabel }})</small>
        }
      </div>
    </ng-template>
  </p-multiselect>
} @else {
  <p-select
    [appendTo]="'body'"
    [options]="displayItems()"
    [filter]="allowSearch()"
    filterBy="firstLabel,secondLabel"
    filterPlaceholder="Search..."
    optionLabel="firstLabel"
    [showClear]="clearable()"
    optionValue="id"
    [placeholder]="placeholder()"
    [(ngModel)]="value"
    [virtualScroll]="virtualScroll()"
    [virtualScrollItemSize]="virtualScrollItemSize()"
    [disabled]="!!ngControl?.control?.disabled"
    [loading]="loading()"
    (ngModelChange)="onValueChange($event)"
    class="w-full"
    [invalid]="hasError"
  >
    <ng-template pTemplate="selectedItem" let-selectedOption>
      <div class="flex items-center gap-2">
        <div>
          {{ selectedOption.firstLabel }}
          @if (selectedOption.secondLabel) {
            <small class="text-muted lh-1 fs-14">&nbsp;({{ selectedOption.secondLabel }})</small>
          }
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="item" let-item>
      <div class="d-flex flex-column px-1 py-1 rounded-2">
        <span class="fs-16 lh-1">{{ item.firstLabel }}</span>
        @if (item.secondLabel) {
          <small class="text-muted lh-1 fs-14">&nbsp;({{ item.secondLabel }})</small>
        }
      </div>
    </ng-template>
  </p-select>
}
<!-- <ng-select
  [items]="items()"
  [searchFn]="searchFn"
  [clearable]="clearable()"
  [multiple]="multiselect()"
  [bindValue]="'id'"
  [placeholder]="placeholder()"
  [(ngModel)]="value"
  [disabled]="!!ngControl?.control?.disabled"
  (ngModelChange)="onValueChange($event)"
  [appendTo]="'body'"
  class="ng-select ng-select-md"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <div class="d-flex align-items-center gap-1 px-1 py-1 rounded-2">
      <div class="d-flex flex-column">
        <span class="fs-16 lh-1"
          >{{ item.firstLabel }}
          @if (item.secondLabel) {
            <small class="text-muted lh-1 fs-14">({{ item.secondLabel }})</small>
          }
        </span>
      </div>
      @if (multiselect()) {
        <span class="ng-value-icon" (click)="clear(item)" aria-hidden="true">×</span>
      }
    </div>
  </ng-template>
  @if (multiselect()) {
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of getTypedItems(items) | slice: 0 : 1; track item.id) {
        <div class="ng-value">
          <div class="d-flex align-items-center gap-1 px-1 py-1 rounded-2">
            <div class="d-flex flex-column">
              <span class="fs-16 lh-1">{{ item.firstLabel }}</span>
              <small class="text-muted lh-1 fs-14">{{ item.secondLabel }}</small>
            </div>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
          </div>
        </div>
      }
      @if (items.length > 1) {
        <div class="ng-value">
          <span class="ng-value-label">+{{ items.length - 1 }}</span>
        </div>
      }
    </ng-template>
  }
  <ng-template ng-option-tmp let-item="item">
    <div class="d-flex flex-column px-1 py-1 rounded-2">
      <span class="fs-16 lh-1">{{ item.firstLabel }}</span>
      <small class="text-muted lh-1 fs-14">{{ item.secondLabel }}</small>
    </div>
  </ng-template>
</ng-select> -->

@if (hasError) {
  <div class="text-danger fs-14">
    <span>{{ errormessage() }}</span>
  </div>
}
